import { createFileRoute } from "@tanstack/react-router";
import FmriGuidedPage from "@/pages/learn/FmriGuidedPage";
import { pageFmriGuided } from "@/pages/learn/learnDataFmriGuided";
export const Route = createFileRoute("/learn/fmri-guided-tms-for-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "What Is fMRI-Guided TMS for Depression? | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "fMRI-guided TMS for depression: what fMRI is, why brain targeting matters, functional connectivity, personalized targets, how SAINT® uses individualized.",
        },
        {
          property: "og:title",
          content: "What Is fMRI-Guided TMS for Depression? | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "fMRI-guided TMS for depression: what fMRI is, why brain targeting matters, functional connectivity, personalized targets, how SAINT® uses individualized.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/learn/fmri-guided-tms-for-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/learn/fmri-guided-tms-for-depression",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(pageFmriGuided.schemaJson),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FmriGuidedPage />;
}
